export default class Accordion {
  constructor() {
    const self = this;
    // this.accordions = document.querySelectorAll("[data-accordion-container]");
    // console.log(this.accordions);
    // if (this.accordions.length <= 0) return;
    //
    if ("onhashchange" in window) {
      // event supported?
      window.onhashchange = function () {
        self.handleAnchorChange(window.location.hash);
      };
    } else {
      // event not supported:
      var storedHash = window.location.hash;
      window.setInterval(function () {
        if (window.location.hash != storedHash) {
          storedHash = window.location.hash;
          self.handleAnchorChange(storedHash);
        }
      }, 100);
    }

    // Initial Call
    self.handleAnchorChange(window.location.hash);
  }

  handleAnchorChange(hash) {
    // Entfernt das "#" Zeichen vom Hash
    const id = hash ? hash.substring(1) : null;

    // Überprüfen, ob ein Element mit der ID existiert
    if (id) {
      // Akkordeon-Element auswählen, das geöffnet werden soll
      const targetAccordion = document.getElementById(id);

      // Wenn das Element gefunden wird
      if (targetAccordion) {
        const accordionButton =
          targetAccordion.previousElementSibling.querySelector(
            ".accordion-button",
          );

        if (accordionButton) {
          accordionButton.click();
          accordionButton.scrollIntoView({ behavior: "smooth" });
          history.replaceState(null, null, " ");
        }
      }
    }
  }

  // handleAccordionClick() {
  //   this.accordions.forEach((accordion) => {
  //     const accordionItems = accordion.querySelectorAll(
  //       "[data-accordion-item]",
  //     );
  //
  //     accordionItems.forEach((item, i) => {
  //       if (i > 6) item.classList.add("d-none");
  //     });
  //   });
  // }
}
